import React, { useEffect, useState } from 'react'

import { withMicrocopy } from '~contexts/MicrocopyContext'
import { selectContent } from '~utils/analytics'

import Button from './Button'

const Component = ({
  explorer,
  endpoint,
  offset,
  microcopy
}) => {
  // only show the button when JS is enabled
  const [enabled, setEnabled] = useState(false)
  useEffect(() => setEnabled(true), [])

  const onClick = () => {
    explorer.toggle()
    selectContent('API Explorer - Enable')
  }

  return <Button
    enabled={enabled}
    explorer={explorer}
    endpoint={endpoint}
    offset={offset}
    microcopy={microcopy}
    onClick={onClick} />
}

export default withMicrocopy(Component)
export { Component as Button }